import React from 'react';
import GymList from '../components/gym/GymList';
import { getGymsAffiliate } from '../view/HTTPService';

/**
 * /gymsallstate - Todos os dojos afiliados (mesmo do /gyms mas com título diferente).
 */
export default function GymsAllStatePage() {
    return (
        <GymList
            titleKey="msg.jkaGyms"
            fetchGyms={getGymsAffiliate}
        />
    );
}
